import { ShoppingCartProduct } from 'src/app/models/shopping-cart/shopping-cart-product';
import { getPriceWithDiscount, getTvaAmountFromPriceHtAndTva } from 'src/app/services/helpers/formula-helper';

export class ShoppingCartProductCategory {
  name: string;
  thumbnail?: string;
  shoppingCartProducts?: ShoppingCartProduct[];

  constructor(name: string, thumbnail?: string, shoppingCartProducts: ShoppingCartProduct[] = []) {
    this.shoppingCartProducts = shoppingCartProducts;
    this.name = name;
    this.thumbnail = thumbnail;
  }

  get totalPriceTtc(): number {
    let total = 0;
    for (const product of this.shoppingCartProducts) {
      total += product.totalPriceTtc + product.totalPriceAccessoryTtc;
    }
    return total;
  }

  get totalPriceTtcWithoutAccessory(): number {
    let total = 0;
    for (const product of this.shoppingCartProducts) {
      total += product.totalPriceTtc;
    }
    return total;
  }

  get totalPriceDiscountTtc(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const product of this.shoppingCartProducts) {
      if (product.totalPriceDiscountTtc != undefined && product.totalPriceDiscountTtc > 0) {
        if (total == undefined) {
          total = 0;
        }
        total += product.totalPriceDiscountTtc + product.totalPriceAccessoryTtc;
      } else {
        totalNotDiscount += product.totalPriceTtc + product.totalPriceAccessoryTtc;
      }
    }
    return total != undefined ? total + totalNotDiscount : total;
  }

  get totalPriceDiscountTtcWithoutAccessory(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const product of this.shoppingCartProducts) {
      if (product.totalPriceDiscountTtc != undefined && product.totalPriceDiscountTtc > 0) {
        if (total == undefined) {
          total = 0;
        }
        total += product.totalPriceDiscountTtc;
      } else {
        totalNotDiscount += product.totalPriceTtc;
      }
    }
    return total != undefined ? total + totalNotDiscount : total;
  }

  get ecoTax(): number {
    let total = 0;
    for (const product of this.shoppingCartProducts) {
      total += product.unitEcoTax != undefined ? product.unitEcoTaxTtc * product.quantity : 0;
    }
    return total;
  }

  get tva(): number {
    let total = 0;
    for (const product of this.shoppingCartProducts) {
      total += getTvaAmountFromPriceHtAndTva(product.unitPriceHtFull * product.quantity, product.tva);
      total += product.tvaAccessory;
    }
    return total;
  }

  get tvaDiscount(): number {
    let totalNotDiscount: number = 0;
    let total: number = undefined;
    for (const product of this.shoppingCartProducts) {
      if (product.discount != undefined && product.discount > 0) {
        if (total == undefined) {
          total = 0;
        }
        total +=
          getTvaAmountFromPriceHtAndTva(
            getPriceWithDiscount(product.unitPriceHt, product.discount) * product.quantity,
            product.tva
          ) + product.tvaAccessory;
      } else {
        totalNotDiscount +=
          getTvaAmountFromPriceHtAndTva(product.unitPriceHt * product.quantity, product.tva) + product.tvaAccessory;
      }
    }
    return total != undefined ? total + totalNotDiscount : total;
  }
}
